import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { FaHome, FaUsers,FaExchangeAlt, FaBuilding, FaUniversity, FaDollarSign, FaTimes } from 'react-icons/fa';
import { toggleSidebar } from '../../redux/slices/uiSlice';
import styles from './Sidebar.module.css';
import { t } from '../../i18n';

const menuItems = [
  { path: '/dashboard', icon: <FaHome />, label: t('ui.layout.home') },
  { path: '/billing', icon: <FaDollarSign />, label: t('ui.layout.billing'), onlyAdmin: false },
  { path: '/transactions', icon: <FaExchangeAlt />, label: t('ui.layout.transactionsList'), onlyAdmin: false },
  { path: '/customers', icon: <FaUsers />, label: t('ui.layout.customers'), onlyAdmin: false },
  { path: '/mosads/:id', icon: <FaBuilding />, label: t('ui.layout.mosadDetails'), onlyAdmin: false },
  { path: '/banks', icon: <FaUniversity />, label: t('ui.layout.banks'), onlyAdmin: true }
];

const Sidebar = () => {
  const dispatch = useDispatch();
  const { sidebarOpen } = useSelector(state => state.ui);
  const { mosadData } = useSelector((state) => state.user);
  // const { mosad } = useSelector(state => state.mosad);

  const handleBackdropClick = () => {
    dispatch(toggleSidebar());
  };

  // Don't render sidebar at all if it's closed
  if (!sidebarOpen) return null;

  return (
    <>
      {/* Mobile backdrop */}
      <div className={styles.backdrop} onClick={handleBackdropClick} />
      <aside className={styles.sidebar}>
      <div className={styles.header}>
        <div className={styles.logo}>
          <img src="/images/masavit-logo-trans.png" alt="מסבית" />
        </div>
        <button
          type="button"
          className={styles.closeBtn}
          onClick={handleBackdropClick}
          aria-label="סגור תפריט"
        >
          <FaTimes />
        </button>
      </div>

      <nav className={styles.nav}>
        {menuItems.map(item => (
          item.onlyAdmin && mosadData?.role !== 'admin' ? null : (
            <NavLink
              key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `${styles.navLink} ${isActive ? styles.active : ''}`
            }
          >
            <span className={styles.icon}>{item.icon}</span>
              <span className={styles.label}>{item.label}</span>
            </NavLink>
          )
        ))}
      </nav>

      <div className={styles.userInfo}>
        <div className={styles.userRole}>
          {mosadData?.role === 'owner' && 'בעל'}
          {mosadData?.role === 'employee' && 'עובד'}
          {mosadData?.role === 'viewer' && 'צופה'}
          {mosadData?.role === 'admin' && 'מנהל'}
        </div>
      </div>
      </aside>
    </>
  );
};

export default Sidebar; 